import React, { useContext, useEffect, useState } from "react";
// import { getPointsStatistics, getReferredUsers } from "../services/referalServices";
import { getProfile } from "../services/authenticationServices";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Hook/AuthProvider";
import "../Referrals.css";
import { Route } from "react-router-dom";
import { RefreshCcw, RefreshCw, RotateCcw } from "lucide-react";
import Header from "./Header";
import Tooltip from "./CustomTooltip";
import {
  getPointsStatistics,
  getReferredUsers,
  regenerateReferralCode,
} from "../services/referalServices";
function Referrals() {
  const steps = [
    {
      number: 1,
      title: "Share your invite link",
      description: "Send your referral link to a friend preparing for UPSC.",
    },
    {
      number: 2,
      title: "They sign up through your link",
      description: "Your friend starts their free trial on Yooki.",
    },
    {
      number: 3,
      title: "Earn 25 Points for every referral",
      description:
        "Get rewarded as soon as your friend joins. These points are your Yooki currency—they never expire.",
    },
    {
      number: 4,
      title: "Earn a 50-Point Bonus for PRO",
      description:
        "Receive an extra 50 points when your friend upgrades to Yooki PRO.",
    },
  ];

  const referralActivities = [
    {
      friend: "John Doe",
      status: "Completed",
      date: "2024-06-01",
      rewards: 50,
    },
    {
      friend: "Jane Smith",
      status: "Pending",
      date: "2024-06-03",
      rewards: 0,
    },
    {
      friend: "Michael Brown",
      status: "Completed",
      date: "2024-06-05",
      rewards: 75,
    },
    {
      friend: "Emily Johnson",
      status: "Completed",
      date: "2024-06-08",
      rewards: 50,
    },
    {
      friend: "David Wilson",
      status: "Rejected",
      date: "2024-06-10",
      rewards: 0,
    },
    {
      friend: "Sarah Miller",
      status: "Pending",
      date: "2024-06-12",
      rewards: 0,
    },
    {
      friend: "Chris Anderson",
      status: "Completed",
      date: "2024-06-15",
      rewards: 100,
    },
    {
      friend: "Olivia Martinez",
      status: "Completed",
      date: "2024-06-18",
      rewards: 50,
    },
    {
      friend: "Daniel Taylor",
      status: "Pending",
      date: "2024-06-20",
      rewards: 0,
    },
    {
      friend: "Sophia Thomas",
      status: "Completed",
      date: "2024-06-22",
      rewards: 75,
    },
    {
      friend: "James Lee",
      status: "Completed",
      date: "2024-06-25",
      rewards: 50,
    },
  ];

  const [copied, setCopied] = useState(false);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // const [profileData, setProfileData] = useState(null);
  const [loader, setloader] = useState(false);
  const [referalCode, setReferalCode] = useState("");
  const [referredUsersData, setReferredUsersData] = useState(null);

  const [referredUsersLoading, setReferredUsersLoading] = useState(true);
  const [regenerateLoading, setRegenerateLoading] = useState(false);
  const [regenerateSuccess, setRegenerateSuccess] = useState(false);

  const navigate = useNavigate();

  const url = process.env.REACT_APP_URL;

  const [referral, setReferral] = useState(
    `${url}referral?code=${localStorage.getItem("referral_code") || ""}`,
  );

  const getMaskedReferral = (refLink) => {
    try {
      if (!refLink) return "";
      const urlObj = new URL(refLink);
      const code = urlObj.searchParams.get("code");
      return code ? `code=${code}` : refLink;
    } catch (e) {
      return refLink;
    }
  };

  // profile api call to get referral code
  // useEffect(() => {
  //   setloader(true)
  //   const fetchProfileData = async () => {
  //     try {
  //       console.log("Fetching profile data...");
  //       const response = await getProfile();
  //       setProfileData(response)
  //       setReferalCode(response.referral_code)

  //     } catch (error) {
  //       console.error("Error fetching profile:", error);
  //     }
  //     finally {
  //       setloader(false);
  //     }
  //   };

  //   fetchProfileData();
  // }, []);

  // points statistics api call
  useEffect(() => {
    // setReferral( `${url}referral?code=${localStorage.getItem('referral_code')  || ""}`);
    const fetchData = async () => {
      try {
        const res = await getPointsStatistics();
        setData(res);
      } catch (err) {
        setError(err.detail || "Failed to load points statistics");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // fetch referred users
  useEffect(() => {
    const fetchReferredUsers = async () => {
      try {
        const res = await getReferredUsers();
        setReferredUsersData(res);
      } catch (err) {
        console.error("Error fetching referred users:", err);
      } finally {
        setReferredUsersLoading(false);
      }
    };

    fetchReferredUsers();
  }, []);

  const handleRegenerate = async () => {
    if (regenerateLoading) return;
    try {
      setRegenerateLoading(true);
      setRegenerateSuccess(false);
      const res = await regenerateReferralCode();
      // Assuming response has referral_code or success
      // Adjust based on actual API response structure.
      // The previous code used res.referral_code
      if (res?.referral_code || res?.code) {
        const newCode = res.referral_code || res.code;
        localStorage.setItem("referral_code", newCode);
        setReferral(`${url}referral?code=${newCode}`);
        setRegenerateSuccess(true);
        setTimeout(() => setRegenerateSuccess(false), 3000);
      }
    } catch (err) {
      console.error("Failed to regenerate code:", err);
    } finally {
      setRegenerateLoading(false);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referral);

      setCopied(true); // show "Copied!"

      setTimeout(() => {
        setCopied(false); // hide after 2 seconds
      }, 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  // if (loading) return <p>Loading...</p>;
  // if (error) return <p style={{ color: "red" }}>{error}</p>;

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // Helper to find specific source data
  const signupData = data?.referral_breakdown?.source_breakdown?.find(
    (s) => s.source_type === "REFERRAL_SIGNUP",
  );
  const proData = data?.referral_breakdown?.source_breakdown?.find(
    (s) => s.source_type === "REFERRAL_PRO",
  );

  // Calculate dynamic widths for the progress bar
  // calculate total points from breakdown
  const totalJoined = data?.referral_breakdown?.referral_transaction_count || 0;
  const totalPoints = data?.referral_breakdown?.total_referral_points || 0;

  // Calculate dynamic widths for the progress bar
  const signupWidth =
    totalPoints > 0 ? ((signupData?.points || 0) / totalPoints) * 100 : 0;
  const proWidth =
    totalPoints > 0 ? ((proData?.points || 0) / totalPoints) * 100 : 0;

  return (
    <div style={{ width: "100%" }}>
      <div>
        <div className="header-biling">
          <Header message={[{ message: `Settings/Referral` }]} flag={false} />
        </div>
      </div>
      <div className="referrals-main-div">
        <div className="referrals-main-div-1st">
          <div className="referrals-main-div-1st-left">
            <span className="referrals-main-div-1st-left-box-text-one">
              Your Points, Your Choice: Redeem Across Yooki
            </span>
            <div className="half-content">
              <span className="referrals-main-div-1st-left-box-text-two">
                Share Yooki. Build Your Rewards.
              </span>
              <span className="referrals-main-div-1st-left-box-text-three">
                Help a friend start strong and earn points for yourself.
              </span>
            </div>
          </div>
          <div className="referrals-main-div-1st-right">
            <img src="/assets/images/Pattern.svg" alt="" />
            <img src="/assets/images/giftbox.svg" alt="" className="postabso" />
          </div>
        </div>
        <div className="referrals-main-div-2nd">
          <div className="referrals-main-div-2nd-left">
            <div className="step-list-detail">
              <span className="step-description">Referral program</span>
              <span className="step-description-line">How Referrals Works</span>
            </div>
            <div className="steps-list">
              {steps.map((step) => (
                <div key={step.number} className="step-item">
                  <div className="step-number">{step.number}</div>
                  <div className="step-content">
                    <h3 className="step-title">{step.title}</h3>
                    <p className="step-description">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="referrals-main-div-2nd-right">
            <div className="referrals-main-div-2nd-right-1st-div">
              <span
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span className="referrals-main-div-2nd-right-text-one">
                  Your Referral Rewards
                </span>
                <span className="referrals-main-div-2nd-right-textbut">
                  {totalJoined} {totalJoined === 1 ? "Person" : "People"} joined
                </span>
              </span>
              <span
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span className="referrals-main-div-2nd-right-text-two">
                  Offer will be applied at checkout
                </span>
                <span className="referrals-main-div-2nd-right-textbut">
                  {totalPoints.toLocaleString()} Points Total
                </span>
              </span>
            </div>
            <div className="point-div">
              <span className="point-text">Points Breakdown :</span>
              <div
                className={`prograssbar ${totalPoints === 0 ? "empty-state" : ""}`}
              >
                {totalPoints === 0 ? (
                  <span className="slider-thumb"></span>
                ) : (
                  <>
                    <span
                      className="signupprog"
                      style={{
                        width: `${signupWidth}%`,
                        transition: "width 0.5s ease-in-out",
                      }}
                    ></span>
                    <span
                      className="upgradproprog"
                      style={{
                        width: `${proWidth}%`,
                        transition: "width 0.5s ease-in-out",
                      }}
                    ></span>
                    <span></span>
                  </>
                )}
              </div>
              <span className="smal-text-stl-main">
                <span className="smal-text-stl">
                  {signupData?.points || 0} Points ({signupData?.count || 0}{" "}
                  sign-ups)
                </span>
                <span className="smal-text-stl">
                  {proData?.points || 0} Points ({proData?.count || 0} PRO
                  Upgrades)
                </span>
              </span>
              <div
                onClick={() => navigate("/Price")}
                className="Redeem-button no-reward"
              >
                {" "}
                <img src="/assets/images/redemgift.svg" alt="" /> Redeem My
                Reward
              </div>
            </div>
            <div className="dashed-line"></div>
            <div>
              <span className="gary-text-small">Invite Link :</span>
              <div className="copy-ref-text">
                {loader ? (
                  <span className="ref-text">Loading...</span>
                ) : (
                  <>
                    <span
                      className={
                        regenerateSuccess
                          ? "ref-text regenerate-success-text"
                          : "ref-text"
                      }
                    >
                      {regenerateSuccess
                        ? "Code Regenerated !"
                        : getMaskedReferral(referral)}
                    </span>
                    <Tooltip text="Regenerate code" position="top">
                      <div
                        className="regenerate-btn"
                        onClick={handleRegenerate}
                      >
                        <RefreshCw
                          color="#ffffffff"
                          height={22}
                          className={regenerateLoading ? "spin-animation" : ""}
                        />
                      </div>
                    </Tooltip>
                  </>
                )}
              </div>
              <span className="gary-text-small">Or share via</span>
              <div className="social-grp">
                <span
                  className="social-media-box"
                  style={{ color: "#37a7d5" }}
                  onClick={handleCopy}
                >
                  {copied ? (
                    "Copied!"
                  ) : (
                    <img src="/assets/images/copyrefer.svg" alt="" />
                  )}
                </span>
                <span
                  className="social-media-box"
                  onClick={() => {
                    const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(referral)}&text=${encodeURIComponent(
                      referral,
                    )}`;
                    window.open(telegramUrl, "_blank");
                  }}
                >
                  <img src="/assets/images/telegram-icon.svg" alt="" />
                </span>
                <span
                  className="social-media-box"
                  onClick={() => {
                    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(referral)}`;
                    window.open(whatsappUrl, "_blank");
                  }}
                >
                  <img src="/assets/images/whatsapp-icon.svg" alt="" />
                </span>
                <span
                  className="social-media-box"
                  onClick={() =>
                    window.open(
                      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        referral,
                      )}`,
                      "_blank",
                    )
                  }
                >
                  <img
                    src="/assets/images/facebook.svg"
                    alt=""
                    height={26}
                    width={26}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <span className="dashed-line-tag"></span>
        <div className="refferrals-main-div-3ird">
          <span className="step-title">Your Referral Activity</span>
          <div className="table-div-data data-empty">
            <table className="caption-side-block">
              <thead>
                <tr className="tr-table-refferal">
                  <th className="tr-table-refferal-left th-text border-line">
                    Friend
                  </th>
                  <th className="th-text border-line">Status</th>
                  <th className="th-text border-line">Date</th>
                  <th className="tr-table-refferal-right th-text border-line">
                    Rewards
                  </th>
                </tr>
              </thead>
              <tbody>
                {referredUsersData?.referred_users?.length > 0 ? (
                  referredUsersData.referred_users.map((item, index) => (
                    <tr key={index}>
                      <td className="border-line td-text">{item.friend}</td>
                      <td className="border-line td-text">{item.status}</td>
                      <td className="border-line td-text">{item.date}</td>
                      <td className="border-line td-text">{item.rewards}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" rowSpan="4" className="no-data-cell">
                      <div className="no-data-wrapper">
                        {/* SVG ICON */}
                        <svg
                          width="88"
                          height="78"
                          viewBox="0 0 88 78"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7234 67.0024C60.1886 67.0024 75.1586 52.0324 75.1586 33.5012C75.1586 14.97 60.1226 0 41.7234 0C23.2581 0 8.28809 14.97 8.28809 33.5012C8.28809 52.0324 23.2581 67.0024 41.7234 67.0024Z"
                            fill="#F5F6FA"
                          />
                          <g filter="url(#filter0_dd_4870_176995)">
                            <path
                              d="M51.4176 15.6952L61.5075 51.9662C61.8372 53.2192 61.1118 54.4722 59.8588 54.8019L24.3132 64.2324C23.0602 64.5621 21.8072 63.8367 21.4775 62.5837L9.07942 15.7611C8.74969 14.5081 9.47511 13.2551 10.7281 12.9254L36.4475 6.13281L51.4176 15.6952Z"
                              fill="white"
                            />
                          </g>
                          <path
                            d="M50.8899 38.6454L31.6992 43.7234L29.5889 44.251L23.192 45.9656C22.9282 46.0315 22.7304 46.3613 22.8623 46.691C22.9282 47.0208 23.258 47.2186 23.5218 47.1526L29.9187 45.438L32.029 44.9104L51.2196 39.8325C51.4834 39.7666 51.6812 39.4368 51.5494 39.1071C51.4834 38.7773 51.1537 38.5795 50.8899 38.6454Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M49.6369 34.1587L42.5146 36.0052L40.0745 36.6647L22.0709 41.4788C21.8071 41.5448 21.6093 41.8745 21.7412 42.2043C21.8071 42.534 22.1369 42.7318 22.4007 42.6659L40.4702 37.8517L42.9103 37.1923L50.0326 35.3457C50.2964 35.2798 50.4942 34.9501 50.3623 34.6203C50.2304 34.3565 49.9007 34.0927 49.6369 34.1587Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M48.5818 29.6065L46.7353 30.0682L44.8888 30.5298L20.818 36.9267C20.5542 36.9926 20.3564 37.3224 20.4883 37.6521C20.5542 37.9818 20.884 38.1797 21.1477 38.1137L45.2185 31.7168L47.2629 31.1893L48.9115 30.7276C49.1753 30.6617 49.3732 30.332 49.2413 30.0022C49.1753 29.7384 48.9115 29.5406 48.5818 29.6065Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M37.4366 52.9575L36.1177 53.2872C35.8539 53.3532 35.5242 53.1553 35.4582 52.8256C35.3923 52.4959 35.5242 52.1661 35.7879 52.1002L37.1069 51.7704C37.3707 51.7045 37.7004 51.9023 37.7664 52.2321C37.8323 52.6278 37.7004 52.8916 37.4366 52.9575Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M33.4135 54.0122L25.8296 55.9906C25.5658 56.0566 25.2361 55.8587 25.1701 55.529C25.1042 55.1992 25.2361 54.8695 25.4999 54.8036L33.0838 52.8251C33.3476 52.7592 33.6773 52.957 33.7433 53.2868C33.8752 53.6165 33.7433 53.9462 33.4135 54.0122Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M47.6586 25.0571L41.6573 26.6399L40.2065 27.0355L19.6969 32.4432C19.4331 32.5092 19.2353 32.8389 19.3672 33.1686C19.4331 33.4984 19.7629 33.6962 20.0266 33.6303L40.4703 28.2885L41.9211 27.8929L47.8564 26.3101C48.1861 26.2442 48.318 25.9144 48.2521 25.5188C48.2521 25.255 47.9223 24.9912 47.6586 25.0571Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M33.4798 15.1023L16.4654 19.5868C16.0697 19.7186 15.674 19.4549 15.5421 19.0592C15.4102 18.6635 15.674 18.2678 16.0697 18.1359L33.0841 13.6515C33.4798 13.5196 33.8755 13.7834 34.0074 14.1791C34.1392 14.5748 33.8755 14.9704 33.4798 15.1023Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M24.1153 21.9617L17.5865 23.6763C17.1908 23.8082 16.7951 23.5444 16.6632 23.1488C16.5313 22.7531 16.7951 22.3574 17.1908 22.2255L23.6536 20.5109C24.0493 20.379 24.445 20.6428 24.5769 21.0384C24.7088 21.4341 24.445 21.8298 24.1153 21.9617Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M36.4473 6.13281L39.0852 16.1568C39.4808 17.5417 40.9976 18.399 42.3825 18.0033L51.4173 15.6952"
                            fill="#D5DAE5"
                          />
                          <g filter="url(#filter1_dd_4870_176995)">
                            <path
                              d="M78.0599 25.9198L71.9928 63.114C71.7949 64.367 70.5419 65.2243 69.2889 64.9605L33.1498 58.6296C31.8968 58.4318 31.0395 57.1788 31.2374 55.9258L39.6127 8.24589C39.8105 6.99289 41.0635 6.13558 42.3165 6.39937L68.5635 11.0157L78.0599 25.9198Z"
                              fill="white"
                            />
                          </g>
                          <path
                            d="M67.9699 46.5578L48.4495 43.1285L46.3392 42.7328L39.8104 41.6117C39.5466 41.5458 39.2169 41.8096 39.2169 42.1393C39.1509 42.4691 39.3488 42.7988 39.6126 42.8647L46.1413 43.9858L48.2517 44.3815L67.7721 47.8108C68.0358 47.8767 68.3656 47.6129 68.3656 47.2832C68.4315 46.9535 68.2996 46.6237 67.9699 46.5578Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M68.7614 42.0109L61.5072 40.7579L59.0671 40.2963L40.6678 37.0649C40.404 36.9989 40.0743 37.2627 40.0743 37.5924C40.0084 37.9222 40.2062 38.2519 40.47 38.3179L58.8693 41.5493L61.3093 42.0109L68.5635 43.2639C68.8273 43.3298 69.157 43.0661 69.157 42.7363C69.223 42.4066 69.0252 42.0769 68.7614 42.0109Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M69.6843 37.3937L67.7719 37.064L65.8594 36.7342L41.327 32.4477C41.0632 32.3817 40.7335 32.6455 40.7335 32.9753C40.6675 33.305 40.8654 33.6347 41.1292 33.7007L65.6615 37.9872L67.7719 38.3829L69.4205 38.6467C69.6843 38.7127 70.0141 38.4489 70.0141 38.1191C70.146 37.7894 70.0141 37.4597 69.6843 37.3937Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M49.7684 53.9454L48.4495 53.7475C48.1857 53.6816 47.9878 53.3519 48.0538 53.0221C48.1197 52.6924 48.3835 52.4286 48.6473 52.4945L49.9663 52.6924C50.2301 52.7583 50.4279 53.0881 50.362 53.4178C50.296 53.8135 50.0322 53.9454 49.7684 53.9454Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M45.7454 53.2227L38.0296 51.9038C37.7658 51.8378 37.5679 51.5081 37.6339 51.1784C37.6998 50.8486 37.9636 50.5849 38.2274 50.6508L45.9432 51.9697C46.207 52.0357 46.4049 52.3654 46.3389 52.6952C46.273 53.0908 46.0092 53.2887 45.7454 53.2227Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M70.7396 32.905L64.6065 31.8498L63.0897 31.586L42.1844 27.893C41.9206 27.827 41.5909 28.0908 41.5909 28.4206C41.525 28.7503 41.7228 29.08 41.9866 29.146L62.8919 32.839L64.4087 33.1028L70.4758 34.158C70.8055 34.2239 71.0693 33.9601 71.1353 33.6304C71.2012 33.3007 71.0034 32.9709 70.7396 32.905Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M62.1011 17.9398L44.7569 14.9063C44.3613 14.8403 44.0975 14.4446 44.1634 14.0489C44.2294 13.6533 44.6251 13.3895 45.0207 13.4554L62.3649 16.489C62.7605 16.5549 63.0243 16.9506 62.9584 17.3463C62.8924 17.676 62.4968 18.0058 62.1011 17.9398Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M50.692 20.1792L44.0314 18.9922C43.6357 18.9262 43.3719 18.5306 43.4378 18.1349C43.5038 17.7392 43.8995 17.4754 44.2951 17.5413L50.8899 18.7284C51.2856 18.7943 51.5493 19.19 51.4834 19.5857C51.4175 19.9814 51.0218 20.2452 50.692 20.1792Z"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M68.4979 11.0156L66.7173 21.2375C66.4535 22.6883 67.5087 24.0732 68.9595 24.337L78.0602 25.9197"
                            fill="#D5DAE5"
                          />
                          <path
                            d="M53.1984 59.6156C61.3205 59.6156 67.9047 53.0314 67.9047 44.9094C67.9047 36.7873 61.3205 30.2031 53.1984 30.2031C45.0764 30.2031 38.4922 36.7873 38.4922 44.9094C38.4922 53.0314 45.0764 59.6156 53.1984 59.6156Z"
                            fill="white"
                          />
                          <path
                            d="M51.814 47.2869C51.7481 47.0231 51.7481 46.7593 51.7481 46.4295C51.7481 45.3084 52.2097 44.3192 53.3968 43.4619L54.386 42.7365C54.9795 42.2749 55.2433 41.7473 55.2433 41.0878C55.2433 40.1646 54.5838 39.2413 53.1989 39.2413C51.7481 39.2413 51.0886 40.4283 51.0886 41.5494C51.0886 41.8132 51.0886 42.0111 51.1545 42.2089L48.5167 42.143C48.4507 41.8792 48.3848 41.5494 48.3848 41.2197C48.3848 38.9775 50.0334 36.8672 53.133 36.8672C56.2984 36.8672 58.0131 38.9116 58.0131 40.9559C58.0131 42.6046 57.1558 43.7257 55.9687 44.583L55.1114 45.1765C54.386 45.7041 53.9903 46.3636 53.9903 47.155V47.2869H51.814ZM52.9351 48.6058C53.8584 48.6058 54.5838 49.3312 54.5838 50.2545C54.5838 51.1777 53.8584 51.9032 52.9351 51.9032C52.0119 51.9032 51.2864 51.1777 51.2864 50.2545C51.3524 49.3972 52.0119 48.6058 52.9351 48.6058Z"
                            fill="#989FB0"
                          />
                          <path
                            d="M75.2109 67.743C74.6401 67.743 74.0692 67.5147 73.6126 67.0009L64.0797 57.468L63.7372 57.6963C60.6547 59.9797 57.0584 61.1784 53.4051 61.1784C49.0097 61.1784 44.6143 59.4088 41.3605 56.3263C37.9355 53.0726 36.0518 48.6772 36.0518 43.8822C36.0518 34.3493 43.8151 26.5859 53.348 26.5859C59.8555 26.5859 65.5638 30.0109 68.6463 35.8334C71.6717 41.5989 71.2722 48.3347 67.5617 53.7576L67.3334 54.1001L76.9234 63.6901C77.8938 64.6605 77.6655 65.6309 77.4942 66.1447C77.0376 67.058 76.1242 67.743 75.2109 67.743ZM53.348 31.3239C46.3838 31.3239 40.7897 36.9751 40.7897 43.8822C40.7897 51.7597 47.2401 56.4976 53.5193 56.4976C57.3438 56.4976 60.8259 54.7851 63.2805 51.7026C66.3059 47.9351 66.8197 42.8547 64.7076 38.4593C62.5384 34.0639 58.2001 31.3239 53.348 31.3239Z"
                            fill="#989FB0"
                          />
                          <defs>
                            <filter
                              id="filter0_dd_4870_176995"
                              x="0"
                              y="1.13281"
                              width="70.5869"
                              height="76.1797"
                              filterUnits="userSpaceOnUse"
                              colorInterpolationFilters="sRGB"
                            >
                              <feFlood
                                floodOpacity="0"
                                result="BackgroundImageFix"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feOffset dy="4" />
                              <feGaussianBlur stdDeviation="4.5" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_4870_176995"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feOffset dy="1" />
                              <feGaussianBlur stdDeviation="0.5" />
                              <feComposite in2="hardAlpha" operator="out" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="effect1_dropShadow_4870_176995"
                                result="effect2_dropShadow_4870_176995"
                              />
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect2_dropShadow_4870_176995"
                                result="shape"
                              />
                            </filter>
                            <filter
                              id="filter1_dd_4870_176995"
                              x="22.209"
                              y="1.35156"
                              width="64.8506"
                              height="76.6562"
                              filterUnits="userSpaceOnUse"
                              colorInterpolationFilters="sRGB"
                            >
                              <feFlood
                                floodOpacity="0"
                                result="BackgroundImageFix"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feOffset dy="4" />
                              <feGaussianBlur stdDeviation="4.5" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_4870_176995"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feOffset dy="1" />
                              <feGaussianBlur stdDeviation="0.5" />
                              <feComposite in2="hardAlpha" operator="out" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="effect1_dropShadow_4870_176995"
                                result="effect2_dropShadow_4870_176995"
                              />
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect2_dropShadow_4870_176995"
                                result="shape"
                              />
                            </filter>
                          </defs>
                        </svg>
                        <p>Refer a friend to unlock rewards and see</p>
                        <p>their status here.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Referrals;
